<script setup lang="ts">
    import { CardMenu } from '@/components/ui/card';
    import Permission from '@/enums/Permission';
    import type { NavItem } from '@/types';

    const navItems: NavItem[] = [
        {
            title: 'system.vat_deadlines_title',
            href: route('v2.vat-deadlines.index'),
            permissionLevel: Permission.SYSTEM_VIEW,
        },
        {
            title: 'system.data_fields_title',
            href: route('v2.data-fields.index'),
            permissionLevel: Permission.SYSTEM_VIEW,
        },
        {
            title: 'kube.page_header',
            href: route('v2.kube.index'),
            permissionLevel: Permission.SYSTEM_VIEW,
        },
        {
            title: 'activities.log_headline',
            href: route('v2.log.index'),
            permissionLevel: Permission.ACTIVITIES_VIEW,
        },
    ];
</script>

<template>
    <CardMenu :items="navItems" />
</template>
